import React from "react";
import { Icon } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

interface Props {
	action: string | undefined;
	isRead: boolean;
}

function NotificationIcon({ action, isRead }: Props) {
	let icon: string;
	let label: string;
	let classType: string;

	// TODO: can move to css?
	// Check what action type the notication is
	// to determine what icon to show
	switch (action) {
		case "invitation":
			icon = "check";
			label = "main.icons.invitation";
			classType = "success";
			break;
		case "overdue":
			icon = "alarm-clock";
			label = "main.icons.overdue";
			classType = "warning";
			break;
		case "read":
			icon = "inbox";
			label = "main.icons.newTask";
			classType = "read";
			break;
		default:
			icon = "inbox";
			label = "main.icons.newTask";
			classType = "info";
	}

	const { t } = useTranslation();

	return (
		<div
			className={`notification-icon-wrapper ${
				isRead ? "read" : "unread"
			} notification-icon-wrapper--${classType}`}
			aria-label={t(label)}>
			<Icon type={icon} size="sm" />
		</div>
	);
}

export default NotificationIcon;
